export default __webpack_public_path__ + "static/media/logo.d46a5e49.png";